module.exports = __webpack_public_path__ + "static/media/3-light-haze-white-compressed.7fea4da1.png";